import loadCss from './internal/_loadCss.js'

/**
 * 根据皮肤路径渲染皮肤
 * @author fangbinwei
 * @param {String} cssUrl 皮肤路径
 */
function renderThemeFromCssUrl (cssUrl, name = 'dolphin') {
  return loadCss(cssUrl, name)
}

export default renderThemeFromCssUrl
